import React from 'react';
import { Outlet } from 'react-router-dom';
import BottomNav from './BottomNav';

/** Logged-in tab pages (Home, Doctors, Appointments, Profile) share the bottom tab bar. */
export default function MemberLayout() {
  return (
    <>
      <Outlet />
      <BottomNav />
    </>
  );
}
